import { call, takeLatest } from 'redux-saga/effects';

import * as constants from './user-groups.constants';
import * as types from './user-groups.types';
import * as services from './user-groups.saga-services';

function* invokeGetUserGroups() {
  yield call(services.getUserGroups);
}

function* invokeCreateUserGroup(action: types.ICreateUserGroup) {
  yield call(services.createUserGroup, action.payload);
}

function* invokeDeleteUserGroup(action: types.IDeleteUserGroup) {
  yield call(services.deleteUserGroup, action.payload);
}

function* invokeUpdateUserGroup(action: types.IUpdateUserGroup) {
  yield call(services.updateUserGroup, action.payload.id, action.payload.name);
}

export function* watchUsersGroupPageSaga() {
  yield takeLatest(constants.GET_USER_GROUPS, invokeGetUserGroups);
  yield takeLatest(constants.CREATE_USER_GROUP, invokeCreateUserGroup);
  yield takeLatest(constants.DELETE_USER_GROUP, invokeDeleteUserGroup);
  yield takeLatest(constants.UPDATE_USER_GROUP, invokeUpdateUserGroup);
}
